module.exports = __webpack_public_path__ + "static/media/solanco.1a0df86c.png";